// extracted by mini-css-extract-plugin
module.exports = {"root":"DroppableCell_root__1y20A","isActive":"DroppableCell_isActive__1ZV7y"};